import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from '@app/util/util';

export function getErrorMessage(payload: HttpErrorResponse): string {
  if (!isEmpty(payload)) {
    if (typeof payload.error === 'string') {
      return payload.error;
    } else {
      return payload.error?.message || payload.message || '';
    }
  } else {
    return '';
  }
}

export function extractAndParseJsonError(logString: string): {[key: string]: string} {
  if (!logString) return null;
  const patterns = [
    /{\\\"code\\\":\\\".*?\\\"}/,
    /\{([^\}]+)\}/,
  ];
  for (const pattern of patterns) {
    const match = logString?.match(pattern)?.[0];
    if (match) {
      try {
        const jsonString = match.replace(/\\"/g, '"').replace(/\\n/g, '');
        return JSON.parse(jsonString);
      } catch (e) {
        continue;
      }
    }
  }
  return null;
}
